import * as yup from 'yup';
import { EMPTY_ARRAY, Row, Column, RenderConfig, SelectInput, NumberInput } from 'commons-ui';
import { BUCKET_OPTIONS } from './constants';

export const FORM_FIELD_KEYS = {
	MAX_VERSION: 'maxAppVersion',
	MIN_VERSION: 'minAppVersion',
	BUCKET: 'bucket',
	LAYOUT: 'layout'
};

export const validationSchema = yup.object().shape({
	minAppVersion: yup.number().required('Min Version is a required field'),
	maxAppVersion: yup
		.number()
		.required('Max Version is a required field')
		.when(['minVersion'], (minVersion, schema) => {
			if (minVersion) {
				return yup
					.number()
					.min(minVersion, 'max version should be greater than min version')
					.typeError('max version is required');
			}
			return schema;
		})
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.MAX_VERSION]: new RenderConfig()
		.setName('maxAppVersion')
		.setLabel('Max Version')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.MIN_VERSION]: new RenderConfig()
		.setName('minAppVersion')
		.setLabel('Min Version')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.BUCKET]: new RenderConfig()
		.setName('bucket')
		.setLabel('Bucket')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BUCKET_OPTIONS,
			required: true
		})
		.setToolTip('SuperApp Live Games bucket name')
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.MIN_VERSION)]),
		new Column([new Row(FORM_FIELD_KEYS.MAX_VERSION)]),
		new Column([new Row(FORM_FIELD_KEYS.BUCKET)])
	])
];
